import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

import { Card } from 'vue-stripe-elements-plus'
import { openStripeCheckout } from '../../../../lib/stripe'


export default /*@__PURE__*/_defineComponent({
  __name: 'StripeCardPay',
  props: {
    mail: { default: '' },
    purchasePrice: { default: null },
    btn: { default: 'カード決済する' },
    title: { default: 'Edbase[エドベース]' },
    description: { default: '' },
    cardComplete: { type: Function, default: () => {} }
  },
  setup(__props: any) {

const props = __props

const onPay = () => {
  openStripeCheckout({
    name: props.title,
    description: props.description,
    amount: props.purchasePrice,
    email: props.mail,
    token: async (token: { id: string }, args: any) => {
      props.cardComplete(token.id)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      color: "primary",
      dark: "",
      onClick: onPay,
      outlined: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.btn), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})